import { useEffect, useState } from "react";
import { api, type BitolaSaldo, type Produto } from "../api.ts";

/**
 * Saldo de pátio por bitola.
 *
 * Mostra os TRÊS números, não só o líquido: quando falta, o operador precisa
 * saber se é porque não há madeira ou porque já está prometida (design §6.4).
 */
export function Estoque({ produtos }: { produtos: Produto[] }) {
  const ativos = produtos.filter((p) => p.ativo);
  const [produtoId, setProdutoId] = useState(() => ativos[0]?.id ?? "");
  const [bitolas, setBitolas] = useState<BitolaSaldo[] | null>(null);

  useEffect(() => {
    if (!produtoId) return;
    setBitolas(null);
    void api
      .get<{ bitolas: BitolaSaldo[] }>(`/estoque/saldo/${produtoId}`)
      .then((r) => setBitolas(r.bitolas))
      .catch(() => setBitolas([]));
  }, [produtoId]);

  const fmt = (v: string) =>
    Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });

  return (
    <>
      <div className="cab-doc">
        <h1>Estoque</h1>
        <select
          className="campo-texto foco-claro" style={{ width: "auto" }}
          value={produtoId} onChange={(e) => setProdutoId(e.target.value)}
          aria-label="Produto"
        >
          {ativos.map((p) => (
            <option key={p.id} value={p.id}>{p.codigo} — {p.especie} {p.forma.toLowerCase()}</option>
          ))}
        </select>
      </div>

      <div className="rolagem">
        <div className="painel">
          {bitolas === null ? (
            <div className="esq">
              {[0, 1, 2, 3, 4].map((i) => (
                <div className="l" key={i}>
                  <span className="b" /><span className="b" /><span className="b" /><span className="b" />
                </div>
              ))}
            </div>
          ) : bitolas.length === 0 ? (
            <div className="vazio">
              <p>Nenhum saldo para este produto.</p>
            </div>
          ) : (
            <table className="tab">
              <thead>
                <tr>
                  <th>Bitola</th>
                  <th style={{ textAlign: "right" }}>Pátio m³</th>
                  <th style={{ textAlign: "right" }}>Reservado m³</th>
                  <th style={{ textAlign: "right" }}>Disponível m³</th>
                  <th style={{ textAlign: "right" }}>Peças</th>
                  <th>Situação</th>
                </tr>
              </thead>
              <tbody>
                {bitolas.map((b, i) => {
                  const disp = Number(b.disponivel);
                  return (
                    <tr key={i}>
                      <td className="mono">
                        {b.espMm ? `${b.espMm} × ${b.largMm} × ${b.compM}` : "—"}
                      </td>
                      <td className="r">{fmt(b.patio)}</td>
                      <td className="r">{fmt(b.reservado)}</td>
                      <td className="r" style={{ color: disp < 0 ? "var(--erro-texto)" : undefined, fontWeight: 600 }}>
                        {fmt(b.disponivel)}
                      </td>
                      <td className="r">{b.pecasPatio.toLocaleString("pt-BR")}</td>
                      <td>
                        {disp < 0
                          ? <span className="pil p-erro"><i />Prometido a mais</span>
                          : disp === 0
                            ? <span className="pil p-aten"><i />Sem folga</span>
                            : <span className="pil p-ok"><i />Livre</span>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
